var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgButtonBad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_492_765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64C49.6731 64 64 49.6731 64 32Z",
    fill: "#E61413"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8462 14.7692C49.8462 19.5274 46.591 23.3846 42.5755 23.3846C38.56 23.3846 35.3049 19.5274 35.3049 14.7692C35.3049 14.7692 38.56 16.6539 42.5755 16.6539C46.591 16.6539 49.8462 14.7692 49.8462 14.7692Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6951 14.7692C28.6951 19.5274 25.44 23.3846 21.4245 23.3846C17.409 23.3846 14.1538 19.5274 14.1538 14.7692C14.1538 14.7692 17.409 16.6539 21.4245 16.6539C25.44 16.6539 28.6951 14.7692 28.6951 14.7692Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0769 48C11.0769 37.1242 20.4446 28.3077 32 28.3077C43.5554 28.3077 52.9231 37.1242 52.9231 48C52.9231 48 43.5554 40 32 40C20.4446 40 11.0769 48 11.0769 48Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_492_765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonBad);
export default __webpack_public_path__ + "static/media/button-bad.97a10580d5a9217071fdfae8bdd076d7.svg";
export { ForwardRef as ReactComponent };